<div class="faq-page__banner">
  <div class="faq-page__banner-img">
    <img alt="Faq article banner image" [src]="'assets/images/faq-article-banner.jpg' | staticFileHash" />
  </div>
</div>

<div class="container">
  <div class="faq-page__container">
    <h1 class="faq-page__title">
      {{ faqTitle }}
    </h1>
    @if (faqDescription) {
      <div class="faq-page__content" [innerHTML]="faqDescription | sanitizeContentfulHTML"></div>
    }
  </div>
</div>
@if (faqFeedback) {
  <app-contentful-feedback [faqFeedback]="faqFeedback" />
}
@if (appsPromo) {
  <app-contentful-apps-promo [appsPromo]="appsPromo" />
}
